import React, { useMemo } from "react";
import { useSearch } from "../../../contexts/SearchContext";
import { mapRawLdsSupplementsToMockupExtras } from "../../../Components/FlightBookingFlowMockup/adapters/flightOfferAdapter";
import { getAvailableExtras } from "../../unifiedFlightSearch/duffelExtras";
import { isHoldEligibleDuffelOffer } from "../../unifiedFlightSearch/flightHoldEligibility";
import { useFlightRealProposalSubmit } from "../../../Components/FlightBookingFlowMockup/flightBookingMockup/context/FlightRealProposalSubmitContext";
import { buildLiveExtrasCatalog, buildLiveReviewViewModel } from "../bridge/liveStageModels";
import { useLiveFlightStage } from "../bridge/useLiveFlightStage";
import ReviewScreen from "./ReviewScreen";

const EDIT_STEP = {
  details: "flightDetails",
  passengers: "passengers",
  extras: "extras",
};

/**
 * Thin live host. ReviewScreen is the preview component.
 */
export default function ReviewLive() {
  const { booking, search, presentation, onBack } = useLiveFlightStage();
  const { savedDeal } = useSearch();
  const { submitHoldFromReview } = useFlightRealProposalSubmit();
  const { selectedFlightOffer, extras, passengers, goToStep } = booking;
  const rawDeal = selectedFlightOffer?.rawDeal ?? savedDeal ?? null;

  const catalog = useMemo(
    () =>
      buildLiveExtrasCatalog({
        roomInfo: search.roomInfo,
        passengers,
        ldsRows: rawDeal ? mapRawLdsSupplementsToMockupExtras(rawDeal) : [],
        duffelExtras: getAvailableExtras(selectedFlightOffer),
        extras,
        baggageLines: presentation.offer?.baggage?.summaryLines || [],
        fare: presentation.offer?.fare || null,
      }),
    [search.roomInfo, passengers, rawDeal, selectedFlightOffer, extras, presentation.offer]
  );

  const review = useMemo(
    () =>
      buildLiveReviewViewModel({
        offer: presentation.offer,
        passengers,
        extrasCatalog: catalog,
      }),
    [presentation.offer, passengers, catalog]
  );

  return (
    <ReviewScreen
      offer={presentation.offer}
      search={presentation.search}
      review={review}
      onContinue={() => {
        if (isHoldEligibleDuffelOffer(selectedFlightOffer)) {
          void submitHoldFromReview();
          return;
        }
        goToStep("draftPayment");
      }}
      onBack={onBack}
      onEditSection={(target) => {
        const step = EDIT_STEP[target];
        if (step) goToStep(step);
      }}
    />
  );
}
